import { BaseTheme, Typography } from '@instructure/shared-types';
import { canvas } from '@instructure/ui-themes';

type ThemeOverride = BaseTheme;

const themeOverride: ThemeOverride = {
  ...canvas,
  key: 'themeOverride',

  typography: {
    fontFamily: '"Lato Extended", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif',
  } as Typography,
};

export default themeOverride;
